module.exports = __webpack_public_path__ + "static/media/css.f5da6f25.svg";